<div *ngIf = "!avisosEmpty">
  <div id="carouselExampleIndicators" class="carousel slide background overlay" data-interval="false">
    <ol class="carousel-indicators">
      <li data-target="#carouselExampleIndicators" *ngFor = "let aviso of avisosVisibles; let i = index" [attr.data-slide-to]="i">{{ i+1 }}</li>
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let aviso of avisosVisibles;let index = index;let isFirst = first" [ngClass]="{active:isFirst}">
        <div class="d-flex">
          <div class="d-flex align-items-center width">
            <img src="assets/aviso/bocadillo_avisos.svg" alt="" class="sizeImg">
          </div>
          <div class="w-100 mt-2 d-inline mb-2">
              <strong id="exampleModalLabel">{{aviso.titulo}}</strong>
              <p>{{ aviso.cuerpo }}</p>
              <div *ngIf="aviso.documento">
                <a (click)="showPdf(aviso.documento, aviso.nombreDocumento)" target="_blank" class="link-info pe-auto"><p> Más información </p></a>  
              </div>
          </div>
        </div>
      </div>
    </div>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
    </a>
  </div>
</div>